import "whatwg-fetch"; // polyfill for older browsers
import { getAPIConfig, handleAPIResponse } from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";

var notificationsAdapter = {
  fetchAllNotifications: async (fetchConfig) => {
    let route = `/notifications${fetchConfig ? `/${fetchConfig}` : ""}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData, []);
  },

  fetchIndividualNotification: async (notificationId) => {
    let route = `/notifications/id/${notificationId}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData, []);
  },

  postNewNotification: async (changes) => {
    let postRoute = changes.hasOwnProperty("message_type") ? "blasts" : null;
    const apiConfig = getAPIConfig(`/notifications/${postRoute}/id`);
    const response = await executeAPIRequest(apiConfig, "POST", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  patchNotification: async (notificationId, changes, type) => {
    type = type === "ScheduledMessage" ? "blasts" : null;
    const apiConfig = getAPIConfig(
      `/notifications/${type}/id/${notificationId}`
    );
    const response = await executeAPIRequest(apiConfig, "PATCH", null, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchNotificationStats: async (notificationId) => {
    const apiConfig = getAPIConfig(
      `/analytics/pn/pn_stats?pn_id=${notificationId}`
    );
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
};
window.notificationsAdapter = notificationsAdapter;

export default notificationsAdapter;
